<template>
  <div class="widget-windbocanes">
    <div class="card" style="height: 40rem; margin-right: 5px;">
      <div class="card-header" style="max-height: 2.3rem; padding-top: 0.25rem;">
        <h5>Vent a Bocanes <small> - darreres dades </small></h5>
      </div>
      <img class="card-img-top" style="max-height: 35rem; min-height: 35rem; object-fit: cover;" :src=data.mapadefons >

      <div class="card-body" style="min-height: 35rem; max-height: 35rem; display: flex;  flex-direction: column;  justify-content: center; padding: 0.2rem;">
        <div class="button border border-white rounded border-4 bg-warning text-dark" style="position:absolute;  left: 0.5rem; top:2.5rem; z-index: 2; width: 14rem;">
          <div class="text-center text-white bg-dark font-weight-bold m-0 p-0">Bocana Nord <small> - {{ data.bocananord.horadeuminutalutc }} h UTC </small></div>
          <table class="table m-0 p-0">
                  <tbody class="m-0 p-0">
                    <tr class="m-0 p-0">
                      <td class="m-0 p-0"><div class="text-center text-dark font-weight-bold m-0 p-0 mb-1" style="line-height:90%; font-size: 1.2rem; width: 9rem;">{{ data.bocananord.ventnomforca }}</div>
                         <p class="text-center text-black m-0 mt-0 p-0" style="font-size: 1.9rem; line-height: 85%;"><b>{{ data.bocananord.ventvelocitatkmh }}</b> <br><span style="font-size:1.4rem;">km/h</span> </p>
                      </td>
                      <td class="m-0 p-0" style="max-width:5.5rem;"><img src="http://www.portdebarcelona.cat/whatsup/static/APB/meteo/PENELL_N.svg" class="m-0 mt-0 p-0" style="max-height:4rem; min-height:4rem;">
                        <div class="text-black text-center font-weight-bold m-0 mb-1 p-0" style="font-size: 1.1rem; line-height: 90%; ">{{ data.bocananord.ventnomdireccio }}</div>
                     </td>
                  </tr>
                 </tbody>
               </table>
        </div>

        <div class="button border border-white rounded border-4 bg-warning text-dark" style="position:absolute;  right: 0.5rem; bottom:9rem; z-index: 2; width: 14rem;">
          <div class="text-center text-white bg-dark font-weight-bold m-0 p-0">Bocana Sud <small> - {{ data.bocanasud.horadeuminutalutc }} h UTC </small>
          </div>
          <table class="table m-0 p-0">
                  <tbody class="m-0 p-0">
                    <tr class="m-0 p-0">
                      <td class="m-0 p-0"><div class="text-center text-dark font-weight-bold m-0 p-0 mb-1" style="line-height:90%; font-size: 1.2rem; width: 9rem;">{{ data.bocanasud.ventnomforca }}</div>
                         <p class="text-center text-black m-0 mt-0 p-0" style="font-size: 1.9rem; line-height: 85%;"><b>1{{ data.bocanasud.ventvelocitatkmh }}</b> <br><span style="font-size:1.4rem;">km/h</span> </p>
                      </td>
                      <td class="m-0 p-0" style="max-width:5.5rem;"><img src="http://www.portdebarcelona.cat/whatsup/static/APB/meteo/PENELL_N.svg" class="m-0 mt-0 p-0" style="max-height:4rem; min-height:4rem;">
                        <div class="text-black text-center font-weight-bold m-0 mb-1 p-0" style="font-size: 1.1rem; line-height: 90%; ">Tramuntana</div>
                     </td>
                  </tr>
                 </tbody>
               </table>

        </div>

      </div>

      <div class="card-footer m-0 ml-1  p-0" style="max-height: 1.5rem; position:absolute; bottom: 0.8rem; left:0.1rem; z-index: auto; ">
            <span class="badge badge-secondary border border-white align-self-sm-end">Informació dels sensors del Port de Barcelona <br>i de Puertos del Estado</span>
         </div>
      

    </div>
    
  </div>
</template>
<script>
export default {
  name: 'Windbocanes',
  props: {
    data: Object
  }
}
</script>